import { Box, Typography } from '@mui/material';

export default function TheoryOfAboutUs() {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <Typography variant="h2" color="text.secondary">
        ሰሜን ሸዋ ሀገረ ስብከት
      </Typography>
      <Typography
        gutterBottom
        variant="h6"
        color="text.secondary"
        textAlign="center"
        sx={{ pt: 1 }}
        fontStyle="oblique"
      >
        በኢትዮጵያ ኦርቶዶክስ ተዋሕዶ ቤተ ክርስቲያን የሰሜን ሸዋ ሀገረ ስብከት / ETHIOPIAN ORTHODOX TEWAHEDO CHURCH NORTH SHOA DIOCESE
      </Typography>
      <Typography gutterBottom variant="h6" color="text.secondary" textAlign="center">
        የሰሜን ሸዋ ሀገረ ስብከት በአማራ ክልል በሰሜን ሸዋ ዞን የሚገኝ የኢትዮጵያ ኦርቶዶክስ ቤተክርስቲያን አህጉረ ስብከት ነው። ብዙ እውቅ የሆኑ ገዳማት እና አድባራት ያሉት ነው።
        የዚህ ድረ-ገጽ ዋና አላማው በሰሜን ሸዋ ሀገረ ስብከት የሚገኙ አውራጃዎችን ፣ አጥቢያዎችን ፣ ካህናትን እና ምዕመናንን መረጃ ለማስተዳደር እና መከታተል ነው።
      </Typography>
      <Typography gutterBottom variant="h6" color="text.secondary" textAlign="center">
        አቡቀለምሲስ ማለት ረአየ ኅቡኣት አበ ራዕይ አበ ትንቢት ማለት ሲሆን የተሰወረውን የተደበቀውን የተከደነውን የሚገልጥ ማለት ነው። መሠራታዊ ዓለማው በሀገረ ስብከታችን ብሎም በመላ
        ቤተ ክርስቲያናችን የተሰወሩ ገዳማትን የተደበቁ ሊቃውንትን የተከደኑ ታሪኮችን የተሸሸጉ ቅርሶችን ማውጣት እና የተንሸዋረረ ታሪክ ማስተካከልና የጎበጠውን አዲሱን ትውልድ ማነጽ
        ነው። አቡቀለምሲስ ማለት ረአየ ኅቡኣት አበ ራዕይ አበ ትንቢት ማለት ሲሆን የተሰወረውን የተደበቀውን የተከደነውን የሚገልጥ ማለት ነው። መሠራታዊ ዓለማው በሀገረ ስብከታችን ብሎም
        በመላ ቤተ ክርስቲያናችን የተሰወሩ ገዳማትን የተደበቁ ሊቃውንትን የተከደኑ ታሪኮችን የተሸሸጉ ቅርሶችን ማውጣት እና የተንሸዋረረ ታሪክ ማስተካከልና የጎበጠውን አዲሱን ትውልድ
        ማነጽ ነው።
      </Typography>
    </Box>
  );
}
